export default __webpack_public_path__ + "static/media/Ballroll_00234.fc8be095.png";